<template>
  <v-container fluid>
    <!-- Заголовок -->
    <v-row>
      <v-col>
        <h1 class="text-h4 font-weight-bold">Панель управления</h1>
      </v-col>
    </v-row>

    <!-- Карточки статистики -->
    <v-row dense>
      <v-col xs="12" sm="6" md="3" v-for="(item, i) in stats" :key="i">
        <v-card outlined>
          <v-card-title class="justify-space-between">
            <span class="text-subtitle-1 font-weight-medium">{{ item.title }}</span>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-card-title>
          <v-card-text class="text-h5 font-weight-bold">{{ item.value }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- График заказов по месяцам -->
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="font-weight-medium">Статистика заказов по месяцам</v-card-title>
          <v-card-text>
            <order-chart />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import OrderChart from "@/components/partner/OrderChart.vue";

export default {
  name: 'DashboardPage',
  components: {OrderChart},
  data () {
    return {
      stats: [
        { title: 'Всего заказов', value: 2450, icon: 'mdi-cart' },
        { title: 'Мои заказы', value: 310, icon: 'mdi-account-box' },
        { title: 'Всего товаров', value: 1340, icon: 'mdi-package-variant-closed' },
        { title: 'Мои товары', value: 75, icon: 'mdi-clipboard-list' },
        { title: 'Покупателей', value: 890, icon: 'mdi-account-group' },
        { title: 'Заказов сегодня', value: 12, icon: 'mdi-calendar-today' },
        { title: 'Заказов за неделю', value: 85, icon: 'mdi-calendar-week' },
      ]
    }
  }
}
</script>
<style scoped>

</style>